import styled from 'styled-components';

export const LinkBlock = styled.ul`
  width: 18%;

  &[dir='ltr'] {
    letter-spacing: 1.5px;
    font-size: 9px;
  }

  &[dir='rtl'] {
    font-size: 12px;
  }

  @media (max-width: 991px) {
    width: 25%;
    margin-bottom: 30px !important;
  }

  @media (max-width: 1199px) and (min-width: 992px) {
    width: 15%;
  }

  @media (max-width: 575.98px) {
    width: calc(50% - 8px);
    margin-bottom: 20px !important;
    margin-bottom: ${({ dir }) => (dir === 'rtl' ? '20px!important' : '')};
  }

  &:last-of-type {
    li {
      span {
        strong {
          font-family: ${({ dir }) =>
            dir === 'rtl' ? 'GESSTwoDWTCMedium,sans-serif ' : 'DINRegular '};
          line-height: ${({ dir }) => (dir === 'rtl' ? '20px' : '1')};
          font-weight: 500;
        }
      }
    }
  }
`;
